var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAfiliado(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50,.99C22.93.99.99,22.93.99,50s21.94,49.01,49.01,49.01,49.01-21.95,49.01-49.01S77.07.99,50,.99M50,19.73c7.86,0,14.24,6.38,14.24,14.25s-6.38,14.25-14.24,14.25-14.25-6.38-14.25-14.25,6.38-14.25,14.25-14.25M78.49,76.71c0,1.97-1.6,3.56-3.56,3.56H25.07c-1.97,0-3.56-1.6-3.56-3.56v-3.56c0-11.8,9.57-21.37,21.37-21.37h14.25c11.8,0,21.37,9.57,21.37,21.37v3.56Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfiliado);
export default __webpack_public_path__ + "static/media/afiliado.22fc54b6fc79518059f8fc33d6b83a0a.svg";
export { ForwardRef as ReactComponent };